import React, { Component } from 'react'
import Graphics from 'components/blottingPaper/Graphics';


import './BlottingPaper.scss';


import { withTranslation } from 'react-i18next'

class BlottingPaper extends Component {

    increacsePrediction = () =>{
        this.props.incPrediction({id: this.props.id, incPrediction: true})
    }
    render()
    {
        return (
          <ul>
            <li
              style={{marginTop: '-30px', paddingTop: '30px'}}
              aria-label = {this.props.t("White sheet with four sections (labeled A, B, C, D).")}
                tabIndex={0}
                className='BlottingPaper'>
                <p aria-hidden="true" className="label">{this.props.t("Blotting Paper")}</p>
                <Graphics id={this.props.id} />
            </li>
          </ul>
        )
    }
}

export default (withTranslation()(BlottingPaper));
